<div
  class="ebo-textarea"
  [class.ebo-textarea--error]="hasError"
  [class.ebo-textarea--focused]="isFocused"
>
  <!-- Label -->
  <label *ngIf="label" class="ebo-textarea__label">
    {{ label }}
    <span *ngIf="required" class="ebo-textarea__required">*</span>
  </label>

  <!-- Textarea Control -->
  <textarea
    [placeholder]="placeholder"
    [rows]="rows"
    [value]="control?.value || ''"
    (input)="onInputChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    class="ebo-textarea__control"
    [style.resize]="resize"
    [attr.aria-label]="label"
    [attr.aria-required]="required"
  ></textarea>

  <!-- Hint Text -->
  <span *ngIf="hint && !hasError" class="ebo-textarea__hint">
    {{ hint }}
  </span>

  <!-- Error Text -->
  <span *ngIf="hasError" class="ebo-textarea__error">
    {{ errorMessage }}
  </span>
</div>
